<template>
  <div>
      <swiper-slide class="slide" v-bind:style="{
              backgroundImage: 'url('+applySliderImage+')',
          }">
        <div v-if="!customizationLocal.slider_multiimage">
          <div class="banner_top_txt">
            <div class="banner_top_left_txt">
              <div class="top_left heading" :style="`font-size: ${offer.heading_size}px; color:${offer.heading_color};`">{{ _T_DB(offer, 'top_left')}}</div>
              <div class="top_left_d description" :style="`font-size: ${offer.desc_size}px; color:${offer.desc_color};`">{{ _T_DB(offer, 'top_left_d')}}</div>
            </div>
            <div class="banner_top_right_txt">
              <div class="top_right heading" :style="`font-size: ${offer.heading_size}px; color:${offer.heading_color};`">{{ _T_DB(offer, 'top_right')}}</div>
              <div class="top_right_d description" :style="`font-size: ${offer.desc_size}px; color:${offer.desc_color};`">{{ _T_DB(offer, 'top_right_d')}}</div>
            </div>
          </div>
          <div class="center_banner_txt">
            <div class="center heading" :style="`font-size: ${offer.heading_size}px; color:${offer.heading_color};`">{{ _T_DB(offer, 'center')}}</div>
            <div class="center description" :style="`font-size: ${offer.desc_size}px; color:${offer.desc_color};`">{{ _T_DB(offer, 'center_d')}}</div>
          </div>
          <div class="banner_bottom_txt">
            <div class="banner_bottom_left_txt">
              <div class="bottom_left heading" :style="`font-size: ${offer.heading_size}px; color:${offer.heading_color};`">{{ _T_DB(offer, 'bottom_left')}}</div>
              <div class="bottom_left_d description" :style="`font-size: ${offer.desc_size}px; color:${offer.desc_color};`">{{ _T_DB(offer, 'bottom_left_d')}}</div>
            </div>
            <div class="banner_bottom_right_txt">
              <div class="bottom_right heading" :style="`font-size: ${offer.heading_size}px; color:${offer.heading_color};`">{{ _T_DB(offer, 'bottom_right')}}</div>
              <div class="bottom_right_d description" :style="`font-size: ${offer.desc_size}px; color:${offer.desc_color};`">{{ _T_DB(offer, 'bottom_right_d')}}</div>
            </div>
          </div>
        </div>
      </swiper-slide>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'OfferSingleTile',
  props: ['offer'],
  data() {
    return {
      txt_color: '#fff', //need to set it according to theme
      size: '30px'
      /*desc_color	#F80101
      desc_size	22
      enabled	true
      heading_color	#FFFFFF
      heading_size:28*/
    }
  },
  computed: {
    ...mapGetters(['_T', '_T_DB','brandStoreParams','brandStoreRoute']),
    ...mapGetters([
      '_T_DB',
      'customizationLocal',
      'all_brand_website_banners',
    ]),
    applySliderImage() {
      if (window.matchMedia('(max-width: 500px)').matches)
      { return this.offer.slider_offer_image_m || this.offer.slider_offer_image}
      else return this.offer.slider_offer_image
    }
  },
  methods: {
    OfferData(offer) {
      this.$store.commit('SET_SELECTED_BRAND', offer.brand_id)
      this.$store.commit('SET_SELECTED_OFFER', offer)
    },
  },
}
</script>

<style lang="scss" scoped>
  .slide {
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: block;
    height: 420px;
  }
  .heading {
    font-weight: bold;
  }
  .description {}
  .banner_class {
    color: $color-primary;
    //font-weight: bold;
  }
  .center_banner_txt {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
  .top_right {
    text-align: right;
  }
  .top_left_d {
    text-align: left;
  }
  .top_left {
    text-align: left;
  }
  .bottom_right {
    text-align: right;
  }
  .bottom_right_d {
    text-align: right;
  }
  .bottom_left {
    text-align: left;
  }
  .banner_top_txt {
    position: absolute;
    left: 18px;
    right: 18px;
    top: 18px;
    display: flex;
    justify-content: space-between;
  }

  .banner_top_left_txt {
    text-align: left;
  }

  .banner_top_right_txt {
    text-align: right;
  }

  .banner_bottom_txt {
    position: absolute;
    left: 18px;
    right: 18px;
    bottom: 62px;
    display: flex;
    justify-content: space-between;
  }

  .banner_bottom_left_txt {}

  .banner_bottom_right_txt {
    text-align: right;
  }
  .bottom_left_d {
    bottom: 0;
    text-align: left
  }
  /*@media (max-width: 575px) {
    .banner_top_txt, .center_banner_txt, .banner_bottom_txt {
      position: unset;
      left: auto;
      right: auto;
      text-align: center;
    }
  }*/
</style>
